import { createContext } from "react";
import { ITenant } from "interfaces/tenant";

const TenantListContext = createContext({
  tenantList: new Array<ITenant>(),
  setTenantList: (tenants: ITenant[]) => {}
});

export default TenantListContext;